export default __webpack_public_path__ + "static/media/carat@3x.fc8cace2.jpg";